import BreakpointMatcher from "./common/breakpoint_matcher";
import Swiper from "swiper/bundle";

class TopProjectSwiper {
  constructor() {
    if (document.querySelector(".p-newProjects1")) {
      this.initialize();
    }
  }

  initialize() {
    const breakpointMatcher = new BreakpointMatcher();

    let swiper;
    const mediaQueryList = breakpointMatcher.matchMedia("md");
    const el = document.querySelector(".p-newProjects1 .swiper");

    const createSwiper = () => {
      if (mediaQueryList.matches) {
        if (swiper) {
          swiper.destroy(false, true);
        }
      } else {
        swiper = new Swiper(el, {
          speed: 777,
          spaceBetween: 48,
          slidesPerView: 1.75,
          centeredSlides: true,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            1024: {
              slidesPerView: 2.25,
            },
            1280: {
              slidesPerView: 3,
            },
            1920: {
              slidesPerView: 3,
            },
          },
        });
      }
    };

    createSwiper();

    mediaQueryList.addEventListener("change", createSwiper);
  }
}

const path = window.location.pathname;
const isRootPath = path === "/projects" || path === "/";

if (isRootPath) {
  window.addEventListener("load", () => {
    new TopProjectSwiper();
  });
}
